<template>
    <div class="background-block">        
    <div class="background-position">
<div class="background-main">
        </div>
        <div class="background-shadow">
        </div> 
    </div>
        <div class="background-logo">
            <h1>МЕГАСАХ</h1>
           <a href="/"><img src="@/assets/images/logo.svg" alt="логоитип" width="120px"></a>
           <p v-html="caption"></p>
        </div>
        
    </div>       
</template>

<script>
import Authentication from "@/components/pages/Authentication";
export default {
  data() {
    return {
      caption: "Закон защищает тех, <br> кто имеет на это право",          
    };
  },
  created() {
    this.getCaption();
  },
  methods: {    
    async getCaption() {        
      let { data } = await Authentication.sendRequestNotAuth(
        this,
        "/api/v1/getcaptionmain",
        "get",
      );
      if (data) {
        this.caption = data.value;
      }
    },  
  },
};
</script>

<style lang="scss">

.background-block{
    position: relative;
    text-align: center;
    margin-bottom: 10px;
}

.background-main{
    width: 100%;
    height: 54vh;
    background-image: url("~@/assets/images/background.jpg");
    background-size: 100vw auto;
    background-position: 50% 50%;
    background-repeat: no-repeat;
}
.background-shadow{
    width: 100%;
    height: 1px;
    background-color: #ccc;
    -webkit-box-shadow: 2px 0 20px 30px #ccc;
    -moz-box-shadow: 2px 0 20px 30px #ccc;
    box-shadow: 2px 0 20px 30px #ccc;
}
.background-logo{
    position: absolute;
    top: 15vh;
    z-index: 3;
    left: 0;
    width: 100%;
    text-align: center;
    h1{
        font-family: Georgia, Times, "Times New Roman", serif;
    }
    a img{
        border-radius: 50%;
        /*background-color: rgb(131 129 129 / 38%);*/
        box-shadow: 2px 2px 20px 1px #000;
        margin-top: 10px;
        margin-bottom: 20px;
    }
    p{
        font-size: 18px;
        text-shadow: 1px 1px 2px #ccc;
    }
}
@media(max-width:1024px){
        .background-main{
            background-size:auto calc(100vw / 1.6 + 200px);
            height: calc(15vh + 350px);
        }
        .background-logo{
            top:10vh;
        }
}
@media(max-width:768px){
        .background-main{
            background-size:auto calc(100vh + 80px);
            height: 60vh;
        }
        .background-logo{
            top:15vh;
        }
}

@media(max-width:420px){
        .background-main{
            background-size:auto calc(100vh + 200px);
            background-position: 50% 70%;
            height: 80vh;
        }
}
</style>